import * as React from 'react';
import RecordsForMonth from '../logic/domain/transits/RecordsForMonth';
import Month from './Month';
import Buttons from './Buttons';
import DayView from './DayView';

interface Props {
  recordsForMonth: RecordsForMonth;
  handleCreateRecord: Function;
  handleUpdateRecord: Function;
  handleDeleteRecord: Function;
  handleCost: Function;
  handleCsv: Function;
  operateMonth: Function;
}

const monthView = (props: Props) => {
  const {
    recordsForMonth,
    handleCreateRecord,
    handleUpdateRecord,
    handleDeleteRecord,
    handleCost,
    handleCsv,
    operateMonth
  } = props;
  const { date } = recordsForMonth;
  const { transitListForDay } = recordsForMonth;

  return (
    <div>
      <nav className="level">
        <div className="level-left">
          <Buttons handleCsv={handleCsv} />
        </div>
        <div className="level-right">
          <Month date={date} operateMonth={operateMonth} />
        </div>
      </nav>
      {transitListForDay.length > 0 ? (
        <div>
          {transitListForDay.map((item, index) => {
            const pathToUpdate = ['transitListForDay', index];
            return (
              <DayView
                key={`${index}+${item.date.toString}`}
                recordForDay={item}
                handleCreateRecord={handleCreateRecord}
                handleUpdateRecord={handleUpdateRecord}
                handleDeleteRecord={handleDeleteRecord}
                handleCost={handleCost}
                pathToUpdate={pathToUpdate}
              />
            );
          })}
        </div>
      ) : (
        <div>No data...</div>
      )}
    </div>
  );
};

export default monthView;



// WEBPACK FOOTER //
// ./src/components/MonthView.tsx